// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38GlN","rootMobile":"styles_rootMobile__5snro"};